import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PasswordDialogComponent } from '../password/password-dialog.component';

@Component({
  selector: 'app-context-menu',
  templateUrl: './context-menu-dialog.component.html',
  styleUrls: ['./context-menu-dialog.component.scss']
})
export class ContextMenuDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { key: string; currentText: string; targetElement: HTMLElement },
    private dialogRef: MatDialogRef<ContextMenuDialogComponent>,
    private dialog: MatDialog
  ) {}

  onEditClicked(): void {
    console.log('Edit support coming soon...');
    this.dialogRef.close();
    this.dialog.open(PasswordDialogComponent, {
      width: '300px',
      data: this.data,
    });
  }

  onCancelClicked(): void {
    this.dialogRef.close();
  }
}
